import { useEffect, useState } from 'react';
import { mcStore, type McRunStatus, type McStoreState } from '@/state/mcStore';

type RunStatusSnapshot = Pick<McStoreState, 'status' | 'runId' | 'startedAt' | 'frozen'>;

export type SizingRunStatus = RunStatusSnapshot & { runInProgress: boolean; isFrozen: boolean };

const createSnapshot = (): RunStatusSnapshot => {
  const state = mcStore.getState();
    return { 
      status: state.status,
      runId: state.runId,
      startedAt: state.startedAt,
      frozen: state.frozen,
    };
  };

export function useSizingRunStatus(): SizingRunStatus {
  const [snapshot, setSnapshot] = useState<RunStatusSnapshot>(() => createSnapshot());

  useEffect(() => {
    return mcStore.subscribe((state) => {
      setSnapshot((prev) => {
        if (
          prev.status === state.status &&
          prev.runId === state.runId &&
          prev.startedAt === state.startedAt &&
          prev.frozen === state.frozen
        ) {
          return prev;
        }
        return {
          status: state.status,
          runId: state.runId,
          startedAt: state.startedAt,
          frozen: state.frozen,
        };
      });
    });
  }, []);

  return {
    ...snapshot,
    runInProgress: snapshot.status === 'running',
    isFrozen: snapshot.frozen,
  };
}

export const sizingRunIsActive = (status: McRunStatus): boolean => status === 'running';
